module.exports = __webpack_public_path__ + "static/media/49.0ef5fd24.mp3";